import { EnemyConfig } from "../../GameConfig/EnemyConfig.js";
import Burst from "../burst.js";

export default class ShipFighterBurst extends Burst {
  constructor() {
    super();

    this.spriteWidth = EnemyConfig.ShipFighter.BURST.SPRITE_WIDTH;
    this.spriteHeight = EnemyConfig.ShipFighter.BURST.SPRITE_HEIGHT;

    this.image.src = EnemyConfig.ShipFighter.BURST.IMG_SRC;
    this.maxFrame = EnemyConfig.ShipFighter.BURST.MAX_FRAME;
  }
}
